/* ============================================
   Maeven Art — Custom PDP JavaScript v7.1
   Featured image swap + simple slider
   v7.1: findVariant defensief voor 1-optie producten (schilderijen)
   ============================================ */

(function() {
  'use strict';

  // === I18N — taal-detectie via Shopify locale, fallback NL ===
  var MA_LOCALE = (
    (window.Shopify && window.Shopify.locale) ||
    document.documentElement.lang ||
    'nl'
  ).slice(0,2).toLowerCase();
  var MA_T = {
    nl: { addToCart:'Toevoegen aan winkelmand', soldOut:'Uitverkocht', unavailable:'Niet beschikbaar', setOf:'Set van' },
    en: { addToCart:'Add to cart',               soldOut:'Sold out',    unavailable:'Unavailable',       setOf:'Set of' },
    de: { addToCart:'In den Warenkorb',          soldOut:'Ausverkauft', unavailable:'Nicht verfügbar',   setOf:'Set von' },
    fr: { addToCart:'Ajouter au panier',         soldOut:'Épuisé',      unavailable:'Indisponible',      setOf:'Ensemble de' }
  };
  var T_ = MA_T[MA_LOCALE] || MA_T.nl;

  document.addEventListener('DOMContentLoaded', function() {
    initPDP();
    initAccordions();
    initScrollReveal();

    /* Vroege klik afspelen. Tot dit punt stonden de kleur-, formaat- en
       aantalknoppen wel op het scherm, maar hing er nog geen handler aan:
       dit bestand komt met defer binnen en bindt hier pas. Het vangnet in
       sections/ma-pdp-hero.liquid onthoudt een klik uit dat gat en geeft
       hem hier alsnog door. Daarna zet het zichzelf uit. */
    if (typeof window.maPdpVroegeKlik === 'function') {
      try { window.maPdpVroegeKlik(); } catch (e) {}
    }
  });

  function initPDP() {
    var section = document.querySelector('[data-ma-pdp]');
    if (!section) return;

    var variantsJson = section.getAttribute('data-ma-variants');
    if (!variantsJson) return;

    var variants;
    try { variants = JSON.parse(variantsJson); } catch(e) { return; }

    var currentColor = section.getAttribute('data-ma-initial-color') || '';
    var currentSize = section.getAttribute('data-ma-initial-size') || '';
    var qty = 1;

    /* Fallback: als geen initiele waarden, gebruik eerste variant */
    if (variants.length > 0) {
      if (!currentColor && variants[0].option1) currentColor = variants[0].option1;
      if (!currentSize && variants[0].option2) currentSize = variants[0].option2;
    }

    /* DOM refs */
    var colorLabel = section.querySelector('[data-ma-color-label]');
    var sizeLabel = section.querySelector('[data-ma-size-label]');
    var priceEl = section.querySelector('[data-ma-price]');
    var compareEl = section.querySelector('[data-ma-compare]');
    var saveEl = section.querySelector('[data-ma-save]');
    var variantInput = section.querySelector('[data-ma-variant-id]');
    var quantityInput = section.querySelector('[data-ma-quantity]');
    var qtyDisplay = section.querySelector('[data-ma-qty-display]');
    var addBtn = section.querySelector('[data-ma-add-btn]');
    var colorBtns = section.querySelectorAll('[data-ma-color]');
    var sizeBtns = section.querySelectorAll('[data-ma-size]');
    var minusBtn = section.querySelector('[data-ma-qty-minus]');
    var plusBtn = section.querySelector('[data-ma-qty-plus]');

    /* Gallery / Slider */
    var slider = document.querySelector('.ma-gallery__slider');
    var track = document.querySelector('[data-ma-track]');
    var slides = document.querySelectorAll('.ma-gallery__slide');
    var thumbs = document.querySelectorAll('[data-ma-thumb]');
    var dotsContainer = document.querySelector('[data-ma-dots]');
    var prevArrow = document.querySelector('[data-ma-prev]');
    var nextArrow = document.querySelector('[data-ma-next]');
    var heroImg = document.querySelector('[data-ma-hero-img]');
    var heroThumb = document.querySelector('[data-ma-hero-thumb]');
    var currentSlide = 0;
    var totalSlides = slides.length;

    /* ============================
       SLIDER
       ============================ */
    function updateSlider() {
      if (!track || !slider || totalSlides === 0) return;
      var w = slider.offsetWidth;
      track.style.transform = 'translateX(-' + (currentSlide * w) + 'px)';

      thumbs.forEach(function(t, i) {
        t.classList.toggle('ma-gallery__thumb--active', i === currentSlide);
      });

      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.ma-gallery__dot');
        dots.forEach(function(d, i) {
          d.classList.toggle('ma-gallery__dot--active', i === currentSlide);
        });
      }

      if (prevArrow) prevArrow.style.visibility = currentSlide > 0 ? 'visible' : 'hidden';
      if (nextArrow) nextArrow.style.visibility = currentSlide < totalSlides - 1 ? 'visible' : 'hidden';
    }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalSlides; i++) {
        var dot = document.createElement('button');
        dot.className = 'ma-gallery__dot' + (i === 0 ? ' ma-gallery__dot--active' : '');
        (function(idx) {
          dot.addEventListener('click', function() { currentSlide = idx; updateSlider(); });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function goNext() { if (currentSlide < totalSlides - 1) { currentSlide++; updateSlider(); } }
    function goPrev() { if (currentSlide > 0) { currentSlide--; updateSlider(); } }

    if (prevArrow) prevArrow.addEventListener('click', goPrev);
    if (nextArrow) nextArrow.addEventListener('click', goNext);

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        currentSlide = i;
        updateSlider();
      });
    });

    /* Touch swipe */
    if (track) {
      var tx = 0;
      track.addEventListener('touchstart', function(e) { tx = e.changedTouches[0].screenX; }, { passive: true });
      track.addEventListener('touchend', function(e) {
        var diff = tx - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) { if (diff > 0) goNext(); else goPrev(); }
      }, { passive: true });
    }

    window.addEventListener('resize', function() { updateSlider(); });

    buildDots();
    updateSlider();

    /* ============================
       HERO IMAGE SWAP (bij kleurwissel)
       ============================ */
    function updateHeroImage() {
      var variant = findVariant(currentColor, currentSize);
      if (!variant || !variant.featured_image) return;
      if (heroImg) {
        heroImg.src = variant.featured_image;
        /* De variant-URL komt binnen op width=900. We bouwen daaruit dezelfde
           srcset-trap als in de Liquid, zodat een kleurwissel niet terugvalt
           op één vaste breedte. Lukt dat niet, dan blijft srcset leeg en is
           het gedrag exact zoals voorheen. */
        heroImg.srcset = '';
        try {
          var basis = variant.featured_image;
          if (/[?&]width=\d+/.test(basis)) {
            heroImg.srcset = [420, 640, 900, 1240]
              .map(function (w) { return basis.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; })
              .join(', ');
            heroImg.sizes = '(min-width: 900px) 612px, 100vw';
          }
        } catch (e) { heroImg.srcset = ''; }
      }
      if (heroThumb) {
        heroThumb.src = variant.featured_image.replace('900x', '200x').replace('width=900', 'width=200');
        heroThumb.srcset = '';
      }
      /* Spring terug naar slide 0 (de hero) */
      currentSlide = 0;
      updateSlider();
    }

    /* ============================
       VARIANT LOGIC
       ============================ */
    /* Defensief: werkt voor producten met 1 OF 2 opties.
       Probeert match-strategieen in volgorde van specifiek naar generiek. */
    function findVariant(color, size) {
      /* 1. Exacte match op beide opties (sets met kleur + maat) */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === color && variants[i].option2 === size) return variants[i];
      }
      /* 2. Producten met alleen option1 (geen size variant) */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === color && !variants[i].option2) return variants[i];
      }
      /* 3. Producten met alleen option2 (geen color variant) — bv schilderijen */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option2 === size && !variants[i].option1) return variants[i];
      }
      /* 4. Match op alleen size (negeer color) */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option2 === size) return variants[i];
      }
      /* 5. Match op alleen color (negeer size) */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === color) return variants[i];
      }
      /* 6. Laatste redmiddel: eerste variant */
      return variants.length > 0 ? variants[0] : null;
    }

    /* 27-08-2026. Hier stonden twee met de hand gebouwde formatters, en die
       hadden allebei geen duizendtalscheidingsteken. Alles boven de duizend
       kwam daardoor als EUR 1030,00 op het scherm, terwijl Liquid met de
       winkelinstelling (money_format = EUR{{amount_with_comma_separator}})
       gewoon EUR 1.030,00 rendert. Geraakt: de 2D set van 12 (1.030), de 3D
       set van 10 (1.120) en de 3D set van 12 (1.325).

       Erger was dat het er TWEE waren met elk een eigen notatie. updateVariant
       draait ook bij het laden, dus je zag al na zeven seconden de kop van de
       uitklap EUR 178,00 zeggen en de rij eronder EUR 178,- .

       Nu een formatter, met exact de notatie van de rest van de winkel.
       formatPriceClean blijft bestaan omdat er op drie plekken naar verwezen
       wordt; hij wijst naar dezelfde functie. */
    function formatPrice(cents) {
      var negatief = cents < 0;
      var abs = Math.abs(cents);
      var euros = Math.floor(abs / 100);
      var rest = abs % 100;
      var heel = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (negatief ? '-' : '') + '\u20AC' + heel + ',' + (rest < 10 ? '0' : '') + rest;
    }

    var formatPriceClean = formatPrice;

    /* De dichte kop van de formaatuitklap gelijkhouden met de keuze.

       27-08-2026. Dit stond als inline <script> onderaan de sectie en deed zijn
       hele werk binnen een requestAnimationFrame.

       ⚠️ CORRECTIE OP MEZELF, en het is het bewaren waard: ik dacht eerst dat die
       listener niet aangehaakt was, want na "Set van 12" kiezen bleef de kop
       "0,5 m2 - EUR 178,00" tonen. Dat was een MEETFOUT. Het tabblad waarin ik
       meette stond op document.hidden = true, en in een verborgen tabblad vuurt
       requestAnimationFrame niet. Alles wat daarin staat lijkt dan kapot terwijl
       het dat niet is. Het oude script was vermoedelijk gewoon goed.

       Waarom het toch hier staat en niet meer in de sectie:
       - het draait nu synchroon vanuit updateVariant, dus niet afhankelijk van een
         renderframe dat er misschien niet komt;
       - de bron is de gekozen variant zelf, niet tekst die uit een rij wordt
         overgeschreven. Een bron, geen kopie;
       - en er is nog maar een implementatie in plaats van twee.

       Les voor de volgende meting: controleer document.hidden voordat je iets dat
       in een rAF zit als kapot bestempelt.  */
    /* Prijs per paneel na de automatische staffelkorting.

       Liquid rekent dit bij het renderen ook uit; deze kopie is er voor het geval
       de prijzen bij een kleurwissel veranderen. Beide lezen dezelfde drempels uit
       data-ma-staffel op de sectie, dus er is een bron en geen tweede waarheid.
       De kortingen staan op BESTELBEDRAG, niet op aantal: op een 3D-set van acht
       (EUR 916) vuurt de drempel van EUR 890 dus al. */
    var staffel = (function () {
      var ruw = (section.getAttribute('data-ma-staffel') || '').split(',');
      var uit = [];
      for (var i = 0; i < ruw.length; i++) {
        var d = ruw[i].split(':');
        var drempel = parseInt(d[0], 10);
        var promille = parseInt(d[1], 10);
        if (drempel > 0 && promille >= 0) uit.push([drempel, promille]);
      }
      uit.sort(function (a, b) { return b[0] - a[0]; });   /* hoogste drempel eerst */
      return uit;
    })();

    function prijsPerPaneel(cent, tegels) {
      var promille = 0;
      for (var i = 0; i < staffel.length; i++) {
        if (cent >= staffel[i][0]) { promille = staffel[i][1]; break; }
      }
      var na = Math.round(cent * (1000 - promille) / 1000);
      return Math.round(na / tegels);
    }

    /* Het lopende totaal in de koopknop: setprijs maal aantal.

       27-08-2026. Hiervoor stond de prijs als los blok van 103 px boven de
       kleurkiezer, en dat duwde de koopknop 63 px onder de vouw. Erger: als de
       aantalkiezer op meer dan een stond, vertelde niets op de pagina wat er in
       de mand ging. Drie keer een set van twaalf is EUR 3.090 en overal op het
       scherm stond EUR 1.030. Nu staat het bedrag in de knop zelf, waar het nul
       hoogte kost en niet meer weg te kijken is. */
    function werkKnopBedragBij(variant) {
      if (!addBtn) return;
      var vak = addBtn.querySelector('[data-ma-add-bedrag]');
      if (!vak) return;
      if (!variant || !variant.available) { vak.textContent = ''; return; }
      vak.textContent = formatPrice(variant.price * (qty || 1));
    }

    function werkMaatKopBij(variant) {
      var maat = document.querySelector('[data-ma-maat]');
      if (!maat || !variant) return;
      var rijen = maat.querySelectorAll('[data-ma-size]');
      var rij = null;
      for (var i = 0; i < rijen.length; i++) {
        if (rijen[i].getAttribute('data-ma-size') === currentSize) { rij = rijen[i]; break; }
      }
      var opp = maat.querySelector('[data-ma-maat-opp]');
      var kopPrijs = maat.querySelector('[data-ma-maat-prijs]');
      if (opp && rij && rij.getAttribute('data-ma-sqm')) {
        opp.textContent = rij.getAttribute('data-ma-sqm') + ' m\u00B2';
      }
      if (kopPrijs) kopPrijs.textContent = formatPrice(variant.price);
      for (var j = 0; j < rijen.length; j++) {
        rijen[j].classList.toggle('ma-maat__rij--actief', rijen[j] === rij);
      }
    }

    /* Uitklap dichtdoen na een keuze. Gedelegeerd op document, zodat het blijft
       werken ook als de uitklap onderweg opnieuw wordt opgebouwd.
       Bewust ZONDER requestAnimationFrame: er is niets om op te wachten, en een
       rAF vuurt niet in een verborgen tabblad. Zie de toelichting hierboven. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var knop = e.target.closest('[data-ma-size]');
      if (!knop) return;
      var maat = knop.closest('[data-ma-maat]');
      if (maat) maat.open = false;
    });

    function updateVariant() {
      var variant = findVariant(currentColor, currentSize);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T_.unavailable; }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        /* Labels uit de sectie-instellingen gaan voor op de vertaaltabel.
           Staat het attribuut er niet, dan blijft het oude gedrag gelden.

           27-08-2026: schrijft in de label-span in plaats van over de hele knop.
           De knop draagt sinds vandaag ook een bedrag-span, en addBtn.textContent
           zou die er bij elke variantwissel uit vegen. */
        var labelTekst = variant.available
          ? (addBtn.getAttribute('data-ma-label-add') || T_.addToCart)
          : (addBtn.getAttribute('data-ma-label-sold') || T_.soldOut);
        var labelSpan = addBtn.querySelector('[data-ma-add-label]');
        if (labelSpan) { labelSpan.textContent = labelTekst; }
        else { addBtn.textContent = labelTekst; }
      }
      werkKnopBedragBij(variant);

      if (priceEl) priceEl.textContent = formatPrice(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatPrice(variant.compare_at_price); compareEl.style.display = ''; }
        if (saveEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          saveEl.textContent = '\u2212' + pct + '%'; saveEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      sizeBtns.forEach(function(btn) {
        var v = findVariant(currentColor, btn.getAttribute('data-ma-size'));
        var ps = btn.querySelector('[data-ma-opt-price]');
        if (ps && v) ps.textContent = formatPriceClean(v.price);
        var pp = btn.querySelector('[data-ma-opt-pp]');
        var tegels = parseInt(btn.getAttribute('data-ma-tiles'), 10);
        if (pp && v && tegels > 0) {
          pp.textContent = formatPrice(prijsPerPaneel(v.price, tegels)) + ' per paneel';
        }
      });

      werkMaatKopBij(variant);
      syncShopifyVariant(variant);
    }

    function syncShopifyVariant(variant) {
      var ss = document.querySelector('[id*="product-grootte"] select, select[id*="product-grootte"]');
      if (ss) { ss.value = variant.option2; ss.dispatchEvent(new Event('change', { bubbles: true })); }
      var cr = document.querySelector('input[name*="kleur"][value="' + variant.option1 + '"]');
      if (cr && !cr.checked) { cr.checked = true; cr.dispatchEvent(new Event('change', { bubbles: true })); }
      var fi = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (fi) fi.value = variant.id;
      if (history.replaceState) history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
    }

    /* Color click */
    colorBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        currentColor = btn.getAttribute('data-ma-color');
        colorBtns.forEach(function(b) { b.classList.remove('ma-swatch--active'); });
        btn.classList.add('ma-swatch--active');
        if (colorLabel) colorLabel.textContent = currentColor;
        updateVariant();
        updateHeroImage();
      });
    });

    /* Size click */
    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        currentSize = btn.getAttribute('data-ma-size');
        sizeBtns.forEach(function(b) { b.classList.remove('ma-bundle__opt--active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('ma-bundle__opt--active');
        btn.setAttribute('aria-pressed', 'true');
        if (sizeLabel) {
          var tiles = btn.getAttribute('data-ma-tiles');
          sizeLabel.textContent = tiles ? T_.setOf + ' ' + tiles : currentSize;
        }
        updateVariant();
        updateHeroImage();
      });
    });


    /* Quantity */
    if (minusBtn) minusBtn.addEventListener('click', function() { if (qty > 1) { qty--; updateQty(); } });
    if (plusBtn) plusBtn.addEventListener('click', function() { qty++; updateQty(); });
    function updateQty() {
      if (qtyDisplay) qtyDisplay.value = qty;
      if (quantityInput) quantityInput.value = qty;
      /* Het bedrag in de knop is een lopend totaal, dus het moet ook mee als
         alleen het aantal verandert en de variant gelijk blijft. */
      werkKnopBedragBij(findVariant(currentColor, currentSize));
    }

    /* Init */
    updateVariant();
  }

  function initAccordions() {
    var triggers = document.querySelectorAll('[data-ma-acc-trigger]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var body = trigger.nextElementSibling;
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
          if (t.nextElementSibling) t.nextElementSibling.setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function initScrollReveal() {
    var reveals = document.querySelectorAll('.ma-reveal');
    if (!reveals.length) return;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('ma-reveal--visible'); });
      }, { threshold: 0.1 });
      reveals.forEach(function(el) { obs.observe(el); });
    } else {
      reveals.forEach(function(el) { el.classList.add('ma-reveal--visible'); });
    }
  }
})();
